// File: src/pages/Directory.jsx

import React from "react";
import CommonHeader from "../components/common/CommonHeader";
import FooterLinks from "../components/LandingPage/FooterLinks";
import CommonSlogan from "../components/common/CommonSlogan";
import CommonFooter from "../components/common/CommonFooter";

export default function Directory() {
  return (
    <div className="bg-black text-white min-h-screen">
      <CommonHeader />

      <main className="max-w-3xl mx-auto py-16 px-4">
        <h1 className="text-3xl font-bold mb-6">
          Directory: Discover and Connect with Market Professionals
        </h1>
        <article className="space-y-8">
          <p className="text-lg leading-relaxed text-gray-200">
            The Million2Trillion Directory is not just a contact list—it's a living, breathing ecosystem of the world’s most ambitious traders, investors, coders, analysts, educators, and financial visionaries.  
            <br /><br />
            In a financial world crowded with noise, finding genuine, verified professionals can feel impossible. That’s why our Directory was created: to unite trusted experts and rising stars under one transparent platform. Here, you don’t just browse names—you discover potential partners, mentors, clients, and collaborators who can help you grow and succeed.
          </p>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">What Makes Our Directory Unique?</h2>
          <ul className="list-disc list-inside ml-4 text-gray-300 space-y-2">
            <li>
              <strong>Fully Verified Profiles:</strong> Every professional is vetted through our SmartCard identity system and KYC, ensuring trust and authenticity in every connection.
            </li>
            <li>
              <strong>Deep Search & Filter:</strong> Don’t waste time scrolling. Instantly filter by role, category, skills, market, region, or even language—so you find exactly who you need, fast.
            </li>
            <li>
              <strong>Live Role Analytics:</strong> See trending roles, top-performing experts, and the most in-demand services in real time, so you always know who’s leading the market.
            </li>
            <li>
              <strong>Dynamic Networking:</strong> Send direct requests, book sessions, invite to deals, or follow professionals to build your personal market network.
            </li>
            <li>
              <strong>Multi-Market Coverage:</strong> From forex and crypto to equities, real estate, and startups—our directory spans 29 categories and 200+ verified roles in 24+ markets.
            </li>
            <li>
              <strong>Zero Spam, Full Privacy:</strong> Our platform is built for professionals only. Your information is secure, and your inbox is protected from unsolicited messages.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">How the Directory Empowers You</h2>
          <ul className="list-disc list-inside ml-4 text-gray-300 space-y-2">
            <li>
              <strong>For Traders & Investors:</strong> Find strategy partners, signal providers, mentors, or build your following as a verified market leader.
            </li>
            <li>
              <strong>For Coders & Analysts:</strong> Showcase your tools, connect with clients, or join teams needing your skills across finance, automation, and AI.
            </li>
            <li>
              <strong>For Educators & Mentors:</strong> Promote your courses, attract students globally, and build a reputation as a thought leader.
            </li>
            <li>
              <strong>For Businesses & Startups:</strong> Source talent, form partnerships, or list your services and products directly in front of a relevant, active audience.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">What You Can Do in the Directory</h2>
          <p className="text-lg text-gray-200">
            The Directory is your portal to:
          </p>
          <ul className="list-disc list-inside ml-4 text-gray-300 space-y-2">
            <li>
              <a className="text-blue-400 underline" >Browse All Professionals</a> — Explore every role, every expert, every market.
            </li>
            <li>
              <a className="text-blue-400 underline" >Find by Role</a> — Traders, analysts, mentors, developers, educators, more.
            </li>
            <li>
              <a className="text-blue-400 underline" >Find by Category</a> — Whether you need fintech, edtech, automation, or research, it’s all here.
            </li>
            <li>
              <a className="text-blue-400 underline">Discover Top Traders</a> and <a className="text-blue-400 underline" href="/directory/investors">Investors</a> — Follow, connect, and learn from the best.
            </li>
            <li>
              <a className="text-blue-400 underline" >Explore Brokers</a> and <a className="text-blue-400 underline" href="/directory/mentors">Mentors</a> — Build your dream team.
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-10 mb-2 text-yellow-300">Why Million2Trillion’s Directory is Different</h2>
          <p className="text-lg text-gray-200">
            Most directories are just static lists. On Million2Trillion, our Directory is a living network—updated in real time, verified by SmartCard, enriched with analytics, and designed to fuel real collaboration.
            <br /><br />
            You don’t just find people; you find opportunities, partnerships, and inspiration. Whether you’re launching a startup, growing your portfolio, or leveling up your career, the Directory is your global launchpad.
          </p>

          <p className="text-lg leading-relaxed text-yellow-400 font-bold mt-8">
            The Million2Trillion Directory is launching soon.<br/>
            Get ready to discover, connect, and build the future of finance—together.
          </p>
        </article>
      </main>

      <FooterLinks />
      <CommonSlogan />
      <CommonFooter />
    </div>
  );
}
